export default __webpack_public_path__ + "static/media/filter.ed56084f.svg";